import React from "react";
import profileImg from "../assets/images/profile.jpg";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={profileImg} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/GregoryTrevor" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/ohanugo-evangel-186a2b35b" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Ohanugo Evangel</h1>
          <p>Computer Scientist | Full Stack Developer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/GregoryTrevor" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/ohanugo-evangel-186a2b35b" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;

